module.exports = __webpack_public_path__ + "static/img/b1.c5e49a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b1.png
// module id = DQjT
// module chunks = 0